import React from "react";

function SelectWebsiteType({
  websiteType,
  setWebsiteType,
  podcastData,
  handleChange,
}) {
  return (
    <div className="flex items-center gap-6 mb-4 text-sm font-medium border-b">
      <button
        type="button"
        className={
          websiteType === "castos"
            ? "border-b-2 border-purple-600 text-purple-600 pb-3"
            : "border-b-2 border-transparent text-gray-600 pb-3"
        }
        onClick={() => setWebsiteType("castos")}
      >
        Create Castos Website
      </button>
      <button
        type="button"
        className={
          websiteType === "custom"
            ? "border-b-2 border-purple-600 text-purple-600 pb-3"
            : "border-b-2 border-transparent text-gray-600 pb-3"
        }
        onClick={() => {
          setWebsiteType("custom");
          if (podcastData.podcast_slug) {
            handleChange("podcast_slug", "");
          }
        }}
      >
        Use My Own Website
      </button>
    </div>
  );
}

export default SelectWebsiteType;
